class StickyProduct extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      addToCartBtn: '[data-sticky-add]',
      container: '.st-prod',
      addToCartMain: `#ProductSubmitButton-${this.dataset.id}`,
      productInfo: 'product-info'
    };
    this.isButtonVisible = true;
    this.init();
  }

  init() {
    this.addToCartBtn = this.querySelector(this.selectors.addToCartBtn);
    this.addToCartMain = document.querySelector(this.selectors.addToCartMain);
    this.container = this.querySelector(this.selectors.container);
    this.productInfo = this.closest('product-info') || document.querySelector(this.selectors.productInfo);
    this.priceSource = document.getElementById(`price-${this.dataset.id}`);
    this.priceTarget = this.querySelector('[data-sticky-price]');
    this.planTarget = this.querySelector('[data-sticky-plan]');
    this.syncPurchase = this.syncPurchase.bind(this);
    this.productInfo?.addEventListener('change', this.syncPurchase);
    if (this.priceSource) {
      this.priceObserver = new MutationObserver(this.syncPurchase);
      this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true, attributes: true });
    }
    this.syncPurchase();
    this.addToCartBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.scrollToBtn();
    });
    window.addEventListener('scroll', () => {
      this.checkButtonVisibility();
    });
    document.addEventListener('DOMContentLoaded', this.checkButtonVisibility.bind(this));
  }

  checkButtonVisibility() {
    if (!this.addToCartMain) return;
    const buttonRect = this.addToCartMain.getBoundingClientRect();
    if (buttonRect.bottom <= 0) {
      if (this.isButtonVisible) {
        this.isButtonVisible = false;
        this.showStickyProduct();
      }
    } else {
      if (!this.isButtonVisible) {
        this.isButtonVisible = true;
        this.hideStickyProduct();
      }
    }
  }

  showStickyProduct() {
    if (this.container && !this.container.classList.contains('active')) {
      this.container.classList.add('active');
    }
  }

  hideStickyProduct() {
    if (this.container && this.container.classList.contains('active')) {
      this.container.classList.remove('active');
    }
  }
  syncPurchase() {
    if (!this.priceSource || !this.priceTarget) return;
    const sale = this.priceSource.querySelector('.price--on-sale .price-item--sale');
    const regular = this.priceSource.querySelector('.price__regular .price-item--regular');
    const price = (sale || regular)?.textContent.trim();
    if (price && this.priceTarget.textContent !== price) this.priceTarget.textContent = price;
    const variant = this.addToCartMain?.form?.querySelector('[name="id"]')?.value;
    const selected = this.productInfo?.querySelector(`input[name="purchaseOption_${this.dataset.id}_${variant}"]:checked`);
    const label = selected?.getAttribute('aria-label')?.split('. Product price')[0] || '';
    if (this.planTarget && this.planTarget.textContent !== label) this.planTarget.textContent = label;
  }

  scrollToBtn() {
    if (this.addToCartMain && this.productInfo) {
      this.productInfo.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      if (!this.addToCartMain.disabled && this.addToCartMain.getAttribute('aria-disabled') !== 'true') {
        this.addToCartMain.click();
      }
    }
  }
}
customElements.define('sticky-product', StickyProduct);


